import { render, staticRenderFns } from "./verifyIdCard.vue?vue&type=template&id=c82dcd12&scoped=true"
import script from "./verifyIdCard.vue?vue&type=script&lang=js"
export * from "./verifyIdCard.vue?vue&type=script&lang=js"
import style0 from "./verifyIdCard.vue?vue&type=style&index=0&id=c82dcd12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82dcd12",
  null
  
)

export default component.exports